var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResizeMax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33325 1.00004C8.33325 0.631851 8.63173 0.333374 8.99992 0.333374H12.9999C13.3681 0.333374 13.6666 0.631851 13.6666 1.00004V5.00004C13.6666 5.36823 13.3681 5.66671 12.9999 5.66671C12.6317 5.66671 12.3333 5.36823 12.3333 5.00004V1.66671H8.99992C8.63173 1.66671 8.33325 1.36823 8.33325 1.00004Z",
    fill: "#5B6885"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.999919 8.33337C1.36811 8.33337 1.66659 8.63185 1.66659 9.00004V12.3334H4.99992C5.36811 12.3334 5.66658 12.6319 5.66658 13C5.66658 13.3682 5.36811 13.6667 4.99992 13.6667H0.999919C0.631729 13.6667 0.333252 13.3682 0.333252 13V9.00004C0.333252 8.63185 0.631729 8.33337 0.999919 8.33337Z",
    fill: "#5B6885"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4712 0.528636C13.7316 0.788986 13.7316 1.2111 13.4712 1.47145L8.80458 6.13811C8.54423 6.39846 8.12212 6.39846 7.86177 6.13811C7.60142 5.87776 7.60142 5.45565 7.86177 5.1953L12.5284 0.528636C12.7888 0.268287 13.2109 0.268287 13.4712 0.528636Z",
    fill: "#5B6885"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13799 7.86201C6.39834 8.12236 6.39834 8.54447 6.13799 8.80482L1.47132 13.4715C1.21097 13.7318 0.788864 13.7318 0.528514 13.4715C0.268165 13.2111 0.268165 12.789 0.528514 12.5287L5.19518 7.86201C5.45553 7.60166 5.87764 7.60166 6.13799 7.86201Z",
    fill: "#5B6885"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeMax);
export default __webpack_public_path__ + "static/media/ResizeMax.a04d87e1.svg";
export { ForwardRef as ReactComponent };